export default __webpack_public_path__ + "static/summer_containers61-8ecb83a5801bc225746b53659bc34ea4.webp";